import React from "react";
import { ShoppingBag, Smartphone, Receipt, Rocket } from "lucide-react";

const META = {
  shopping: { title: "Shopping", icon: ShoppingBag, desc: "Use your wallet balance for electronics, gift cards, lifestyle & more." },
  recharge: { title: "Mobile Recharge", icon: Smartphone, desc: "Recharge prepaid mobiles across all operators and circles." },
  billpay: { title: "Bill Payments", icon: Receipt, desc: "Pay electricity, water, gas, DTH, broadband, FASTag & BBPS bills." },
};

export default function Services({ service }) {
  const m = META[service];
  const Icon = m.icon;
  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-teal-50 text-teal-600 flex items-center justify-center"><Icon className="w-6 h-6" /></div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-[#0B223D]">{m.title}</h1>
      </div>
      <p className="text-slate-500">{m.desc}</p>

      <div className="bg-brand-gradient text-white rounded-2xl p-10 text-center" data-testid={`service-${service}-status`}>
        <Rocket className="w-12 h-12 mx-auto text-teal-300 mb-4" />
        <h3 className="font-display font-extrabold text-2xl">Coming Soon</h3>
        <p className="text-white/80 mt-2 max-w-md mx-auto">
          {m.title} is launching soon for Credit Kendra members. You'll be able to spend your wallet balance here — stay tuned!
        </p>
      </div>
    </div>
  );
}
